import { Component, effect, ChangeDetectionStrategy } from '@angular/core';
import { startWith, map } from 'rxjs/operators';
import { SearchComponent } from '../search/search.component';

@Component({
    selector: 'app-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AutocompleteComponent extends SearchComponent {
    constructor() {
        super();

        effect(() => {
            const formControl = this.formControl();

            if (formControl) {
                const meta = this.meta();
                const items = this.items();

                this.filtered = formControl.valueChanges
                    .pipe(
                        startWith(''),
                        map(value => typeof value === 'string' ? value : !!value ? meta.display(value) : ''),
                        map(name => name ? this.filterItems(name) : items.slice())
                    );
            }
        });
    }
}
